import React, {ChangeEvent, FormEvent, useState} from "react";


type PropType = {
    setIsPhoneNumberSubmitted: React.Dispatch<React.SetStateAction<boolean>>;
    phoneNumber: string;
    setPhoneNumberState: (phoneNumber: string) => void;
    onSubmitPhoneNumber: () => void
};

const PhoneLogin: React.FC<PropType> = ({
                                            setIsPhoneNumberSubmitted,
                                            onSubmitPhoneNumber,
                                            phoneNumber,
                                            setPhoneNumberState,
                                        }) => {


    const [showIncorrectPhoneError, setShowIncorrectPhoneError] = useState<boolean>(false)


    function handleSubmitPhoneNumber(e: FormEvent<HTMLFormElement>) {
        e.preventDefault()
        if (phoneNumber.length < 10) {
            setShowIncorrectPhoneError(true);
            return
        }

        setShowIncorrectPhoneError(false);
        setIsPhoneNumberSubmitted(true);
        onSubmitPhoneNumber()

    }


    const handleInput = (e: ChangeEvent<HTMLInputElement>) => {

        const {value} = e.target;
        // Only proceed if the value is a digit and the current length is less than 10
        if (/^[0-9]*$/.test(value) && value.length <= 10) {
            setPhoneNumberState(String(value));
        }
    };

    return (
        <main className="relative  flex flex-col justify-center overflow-hidden">
            <div className="w-full max-w-[90rem] mx-auto px-4 md:px-6 ">
                <div className="flex justify-center">
                    <div className="max-w-md mx-auto text-center bg-white px-4 sm:px-8 lg:py-8  ">
                        <header className="mb-8">
                            <h1 className="text-3xl font-bold mb-1">Sign in</h1>
                            <p className="text-lg mt-4 text-slate-500">
                                Please Enter your phone number to continue.
                            </p>
                        </header>
                        <form onSubmit={handleSubmitPhoneNumber}>
                            <div className="flex items-center justify-center gap-3">
                                <div className="flex items-center">
                                    <button id="dropdown-phone-button" data-dropdown-toggle="dropdown-phone"
                                            className="flex-shrink-0 z-10 inline-flex items-center py-2.5 px-4 text font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-s-lg hover:bg-gray-200 "
                                            type="button">

                                        +91
                                    </button>

                                    <label htmlFor="phone-input"
                                           className="mb-2 text-sm font-medium text-gray-900 sr-only">Phone
                                        number:</label>
                                    <div className="relative w-full">
                                        <input type="text" onChange={handleInput}
                                               value={phoneNumber ? Number(phoneNumber) : ""} id="phone-input"
                                               aria-describedby="helper-text-explanation"
                                               className="block  p-2.5 w-[15rem] pl-5 mx-auto  z-20 text text-gray-900 bg-gray-50 rounded-e-lg border-s-0 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 font-medium"
                                               placeholder="123-456-7890"
                                        />
                                    </div>

                                </div>

                            </div>
                            {showIncorrectPhoneError &&
                                <p className={"mt-2 text-red-600 text-xs "}>Requires at least 10 digit</p>}
                            <div className="max-w-[18.5rem] mx-auto mt-8">
                                <button
                                    type="submit"
                                    className="w-full bg-cc_brand inline-flex justify-center whitespace-nowrap rounded-lg  px-3.5 py-2.5 text-sm font-medium text-white shadow-sm shadow-indigo-950/10 hover:bg-indigo-600 focus:outline-none focus:ring focus:ring-indigo-300 focus-visible:outline-none focus-visible:ring focus-visible:ring-indigo-300 transition-colors duration-150"
                                >
                                    Verify Account
                                </button>
                            </div>
                        </form>
                        <div className="text-sm text-slate-500 mt-4">

                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default PhoneLogin